'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import leaveAction from '../../actions/leaveAction';
import leaveStore from '../../stores/leaveStore';
import userStore from '../../stores/userStore';
import genFunction from '../../functions/genFunction';

class LeaveFilter extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handlePrint = this.handlePrint.bind(this);
        this.handleExport = this.handleExport.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onUserChange = this.onUserChange.bind(this);
        this.state = {
            processing: leaveStore.getState().processing,
            iniYear: 2017,
            iniMonth: 11,
            staffId: leaveStore.getState().staffId,
            startYear: leaveStore.getState().startYear,
            startMonth: leaveStore.getState().startMonth,
            endYear: leaveStore.getState().endYear,
            endMonth: leaveStore.getState().endMonth,
            warningMsg: leaveStore.getState().warningMsg,

            permission: userStore.getState().permission,
            subordinate: userStore.getState().subordinate,
            userId: userStore.getState().staffId
        };
    }
    static defaultProps = {
        mthTxt: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    };
    componentDidMount() {
        leaveStore.listen(this.onChange);
        userStore.listen(this.onUserChange);
        //set default staffId
        this.setState({
            staffId: ""
        });
    }
    componentWillUnmount() {
        leaveStore.unlisten(this.onChange);
        userStore.unlisten(this.onUserChange);
    }
    onUserChange(state) {
        this.setState({
            permission: state.permission,
            subordinate: state.subordinate,
            userId: state.staffId
        });
    }
    onChange(state) {
        this.setState({
            processing: state.processing,
            startYear: state.startYear,
            startMonth: state.startMonth,
            endYear: state.endYear,
            endMonth: state.endMonth,
            staffId: state.staffId
        });
    }
    handleChange(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        let value = e.target.value.split(":");
        let selectedYear = parseInt(value[0]);
        let selectedMonth = parseInt(value[1]);
        console.log(selectedMonth);
        if (index == 0) {
            leaveAction.updateSM({ startYear: selectedYear, startMonth: selectedMonth });
        } else if (index == 1) {
            leaveAction.updateEM({ endYear: selectedYear, endMonth: selectedMonth });
        } else if (index == 2) {
            leaveAction.updateUI({ staffId: value[0] });
        }

    }
    handlePrint() {
        window.print();
    }
    handleSubmit() {
        if (!this.state.processing) {
            leaveAction.clear();
            leaveAction.warningMsg("");
            leaveAction.processing(true);
            leaveAction.getLA(this.state.staffId, this.state.startYear, this.state.startMonth, this.state.endYear, this.state.endMonth);
        }
    }
    handleExport() {
        if (!this.state.processing) {

            leaveAction.warningMsg("");
            leaveAction.processing(true);
            leaveAction.exportLA(this.state.staffId, this.state.startYear, this.state.startMonth, this.state.endYear, this.state.endMonth);
        }
    }
    renderOption(yr, mth) {
        return (<option value={yr + ":" + mth} key={yr * 100 + mth}>{this.props.mthTxt[mth] + " " + yr}</option>);
    }
    renderStaff(staff, index) {
        return (<option value={staff.staffId} key={index}>{staff.userName}</option>);
    }
    renderStaffs() {
        let staffs = this.props.staffs.filter((staff) => {
            return (genFunction.hasPermission(this.state.permission, 2) ||
                genFunction.isSubordinate(this.state.subordinate, staff.staffId) ||
                genFunction.isUser(this.state.userId, staff.staffId) ||
                genFunction.isMember(this.props.teamMember, staff.staffId)
            );
        });
        return staffs.map((staff, index) => {
            return (
                this.renderStaff(staff, index)
            );
        });
    }
    renderOptions() {
        let options = [];
        let thisYear = new Date(new Date().getFullYear(), new Date().getMonth() + 12).getFullYear();
        let thisMonth = new Date(new Date().getFullYear(), new Date().getMonth() + 12).getMonth();

        for (let yr = thisYear; yr >= this.state.iniYear; yr--) {
            if (thisYear == this.state.iniYear) {
                for (let mth = thisMonth; mth >= this.state.iniMonth; mth--) {
                    options = options.concat(this.renderOption(yr, mth));
                }
            } else if (yr == thisYear) {
                for (let mth = thisMonth; mth >= 0; mth--) {
                    options = options.concat(this.renderOption(yr, mth));
                }
            } else if (yr == this.state.iniYear) {
                for (let mth = 11; mth >= this.state.iniMonth; mth--) {
                    options = options.concat(this.renderOption(yr, mth));
                }
            } else {
                for (let mth = 11; mth >= 0; mth--) {
                    options = options.concat(this.renderOption(yr, mth));
                }
            }

        }
        return options;
    }
    render() {
        let startValue = this.state.startYear + ":" + this.state.startMonth;
        let endValue = this.state.endYear + ":" + this.state.endMonth;
        return (
            <div className="atd-i row">
                <div className="col-md-4 col-lg-3">
                    <form className="form-horizontal atd-i-wp">
                        <label htmlFor="startFrom" className="col-xs-4 control-label">Start from: </label>
                        <div className="input-group input-group-sm">
                            <select className="form-control atd-sel" name="startFrom" data-index="0"
                                value={startValue}
                                onChange={this.handleChange}>
                                {this.renderOptions()}
                            </select>
                        </div>

                    </form>
                    <form className="form-horizontal atd-i-wp">
                        <label htmlFor="endMonth" className="col-xs-4 control-label">Till: </label>
                        <div className="input-group input-group-sm">
                            <select className="form-control atd-sel" name="endMonth" data-index="1"
                                value={endValue}
                                onChange={this.handleChange}>
                                {this.renderOptions()}
                            </select>
                        </div>
                    </form>
                </div>
                <div className="col-md-4 col-lg-3">
                    <form className="form-horizontal atd-i-wp">
                        <label htmlFor="staffName" className="col-xs-4 control-label">Staff Name: </label>
                        <div className="input-group input-group-sm">
                            <select className="form-control atd-sel" name="staffName" data-index="2" onChange={this.handleChange}>
                                {<option value="" >Any Staff</option>}
                                {this.renderStaffs()}
                            </select>
                        </div>
                    </form>
                    <div className="atd-0-tp atd-i-btn">
                        <button className="btn btn-default btn-sm" type="button" onClick={this.handleSubmit}>Search</button>
                    </div>
                    <div className="atd-0-tp atd-i-btn">
                        <button className="btn btn-primary btn-sm" type="button" onClick={this.handlePrint}>Print</button>
                    </div>
                    <div className="atd-0-tp atd-i-btn">
                        <button className="btn btn-primary btn-sm" onClick={this.handleExport}>Export</button>
                    </div>
                    <div className="warning">{this.state.warningMsg}</div>
                </div>
            </div>

        );
    }
}
export default LeaveFilter;


// WEBPACK FOOTER //
// ./app/components/leaveComponents/leaveFilter.js